var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outLinkBox"},_vm._l((_vm.outLinkList),function(e,index){return _c('div',{key:index,staticClass:"outLinkItem",on:{"click":function($event){return _vm.outLink(e)}}},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":e.srcUrl,"alt":e.name}})]),_c('p',{staticClass:"text"},[_vm._v(_vm._s(e.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }